import React from 'react';

import Modal from '../../../../components/Modal';
import RadioGroup, { Radio } from '../../../../components/RadioGroup';

// map

export const manifestFilters = {
  ALL: '',
  DELIVERY_ONLY: 'DISTRIBUICAO',
  TRANSFER_ONLY: 'VIAGEM',
};

function DashboardCompletedManifestModal({
  manifestType,
  onChangeValue,
  ...props
}) {
  return (
    <Modal title="Tipo de viagem" size="small" {...props}>
      <RadioGroup value={manifestType} onChangeValue={onChangeValue}>
        <Radio value={manifestFilters.DELIVERY_ONLY} label="Somente entregas" />
        <Radio
          value={manifestFilters.TRANSFER_ONLY}
          label="Somente transferências"
        />
      </RadioGroup>
    </Modal>
  );
}

export default DashboardCompletedManifestModal;
